var app = {

	settings: {
	},

	vars: {
	},

	init: function() {
		this.initGlobalExtensions();
		this.initLocalExtensions($('body'));
	},

	parse: function($context) {
		this.initLocalExtensions($context);
	},

	initGlobalExtensions: function() {
		var t = this;
		for (var globalExt in t.globalExt) {
			if (!app.obj[globalExt]) {
				app.obj[globalExt] = new t.globalExt[globalExt]();
			}
		}
	},

	initLocalExtensions: function($context) {
		var t = this; 
		for (var ext in t.ext) {
			var $els = $context.findOrSelf('.js-' + ext);
			$els.each(function() {
				var fn = new t.ext[ext]($(this));
				if (app.obj[ext] === undefined) app.obj[ext] = [];
				if ($(this).data('objectName')) {
					app.obj[ext][$(this).data('objectName')] = fn;
				} else {
					app.obj[ext].push(fn);
				}
			});
		}
	},

	ext: {},
	globalExt: {},
	obj: {},
};

$(function() {
	app.init();
});

$.fn.findOrSelf = function(selector) {
	return this.find(selector).add(this.filter(selector));
};

app.globalExt['global-structure'] = function() {
	var api = {};

	var init = function() {
		
	};

	init();	return api;
};

app.ext['local-structure'] = function($el) { 
	var api = {};

	var init = function() {
		
	};

	init();	return api;
};
